<template>
  <div id="templates" ref="templatesRef">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1" fab absolute right class="mr-3 pf-btn-fab" @click="addNewTemplate">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid v-if="editIndex === -1">
      <v-layout wrap row>
        <v-flex v-for="item in templateList" :key="item.id" xs12 sm6 md4 lg3>
          <div class="itemWrapper">
            <v-card hover @click="editItem(item)">
              <img v-if="item.default_page"
                :src="config.uploadPath + item.default_page.webPath"
                :alt="item.name"
                width="100%"
              />
              <img
              v-else
              :src="defaultIcon"
              :alt="item.name"
              width="100%"
              height="230px"
              />
              <v-card-actions>
                <h5 class="templateName">{{item.name.toUpperCase()}}</h5>
              </v-card-actions>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form v-else ref="formEdit">
      <v-container class="-border">
        <v-layout class="pr-4 pl-4" wrap>
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="editData.selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="mt-2">
          <v-flex class="xs12 sm6">
            <v-text-field label="Template Name" :rules="[rules.templateName]" v-model.trim="editData.name" class="required pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex class="xs12 sm6">
            <v-text-field label="Demo URL" :rules="[rules.url]" v-model="editData.demo_url" class="pr-4 pl-4" @input="changedData" hint="Ex: https://cdn.parentfinder.com/flipbook/19_3303/19_3303.html"></v-text-field>
          </v-flex>
          <v-layout>
            <v-flex>
              <div id="pageEditor">
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex sm12>
                      <quill-editor
                        class="quill"
                        :content="editData.description"
                        :options="editData.editorOption"
                        v-model="editData.description"
                        @input="changedData"
                      >
                      </quill-editor>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
          </v-layout>
          <v-layout container class="pt-0">
            <v-flex xs12 sm12 v-if="templateItems">
              <v-card class="mt-4 pt-1 pl-2 pr-2" v-for="(item, i) of templateItems" :key="i">
              <v-layout row wrap class="custom-wrap">
                <v-flex sm11>
                  <h4 class="ml-4 pt-2 pb-2">{{item.name}}</h4>
                </v-flex>
                <v-flex sm1 class="text-xs-right" v-if="item.name !== 'Colors'">
                  <v-layout row wrap class="mr-1 pl-2">
                    <upload-btn multiple icon class="template-upload-icon" @file-update="fileSelected($event, i, item.name)">
                      <template slot="icon">
                        <v-icon>add</v-icon>
                      </template>
                    </upload-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
              <div v-if="item.name === 'Pages'">
                <v-container grid-list-sm class="pa-1 pb-3">
                  <v-layout row wrap>
                     <draggable v-model="editData.page" class="layout wrap row" handle=".sortHandle" @start="drag=true" @end="drag=false;" @change="sortList" forceFallback="false">
                      <v-flex v-for="(page, n) in editData.page" :key="n" xs12 sm4 md3 class="pr-2 pl-2 templateFile">
                          <v-card v-if="page">  
                            <img :src="config.uploadPath + page.webPath" width="100%">
                            <v-divider horizontal></v-divider>
                            <v-flex flat class="text-xs-right pa-1 custom-bg" >
                              <v-btn icon class="ma-0 sortHandle">
                                <v-icon size="22" color="grey darken-2">open_with</v-icon>
                              </v-btn>
                              <v-btn icon class="ma-0" v-if="page._id === editData.default_page._id">
                                <v-icon size="22" color="pink lighten-3">star</v-icon>
                              </v-btn>
                              <v-btn icon class="ma-0" v-if="page._id !== editData.default_page._id" @click="makeCover(page)">  
                                <v-icon size="22" color="grey darken-2">star_border</v-icon>
                              </v-btn>
                              <v-btn icon @click="removeItem(page, 'Page')" class="ma-0">
                                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-card>
                      </v-flex>
                    </draggable>
                  </v-layout>
                </v-container>
              </div>
              <div v-if="item.name === 'Colors'">
                <v-container grid-list-sm class="pa-1 pb-3">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Primary color</span>
                      <v-btn block :color="templateColors.front_cover" @click="pickFrontCoverColor = !pickFrontCoverColor"></v-btn>
                      <chrome-picker :value="templateColors.front_cover" @input="changeColor($event, 'front_cover')" v-if="pickFrontCoverColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Background cover color</span>
                      <v-btn block :color="templateColors.background_cover" @click="pickBackCoverColor = !pickBackCoverColor"></v-btn>
                      <chrome-picker :value="templateColors.background_cover" @input="changeColor($event, 'background_cover')" v-if="pickBackCoverColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Border color</span>
                      <v-btn block :color="templateColors.border" @click="pickBorderColor = !pickBorderColor"></v-btn>
                      <chrome-picker :value="templateColors.border" @input="changeColor($event, 'border')" v-if="pickBorderColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Title headings</span>
                      <v-btn block :color="templateColors.title_heading" @click="pickTitleHeadColor = !pickTitleHeadColor"></v-btn>
                      <chrome-picker :value="templateColors.title_heading" @input="changeColor($event, 'title_heading')" v-if="pickTitleHeadColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Border around photos</span>
                      <v-btn block :color="templateColors.photo_border" @click="pickPhotoBorderColor = !pickPhotoBorderColor"></v-btn>
                      <chrome-picker :value="templateColors.photo_border" @input="changeColor($event, 'photo_border')" v-if="pickPhotoBorderColor"></chrome-picker>
                    </v-flex>
                    <v-flex xs12 sm6 class="pr-4 pl-4 pb-4">
                      <span class="pf-sub-head mb-3 custom-title">Inside background colors</span>
                      <v-btn block :color="templateColors.insidebackground_color" @click="pickInsideBGColor = !pickInsideBGColor"></v-btn>
                      <chrome-picker :value="templateColors.insidebackground_color" @input="changeColor($event, 'insidebackground_color')" v-if="pickInsideBGColor"></chrome-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>              
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mb-3 pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="editData.selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>      
    </v-form>
  </div>
</template>
<script>
/* global session router store config */
import swal from 'sweetalert2';
import { getCollection, update, remove, updateSortList, sortList, uploadFile, validateUrl } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import UploadButton from 'vuetify-upload-button';
import { Chrome } from 'vue-color';
export default {
  components: {
    'upload-btn': UploadButton,
    quillEditor,
    draggable,
    'chrome-picker': Chrome
  },  
  data: () => ({
    entity: 'Template',
    editIndex: -1,
    currentCoverPage: null,
    deleteIndex: null,
    currentEditor: null,
    config: config,
    editData: {
      name: '',
      description: '',
      selectedData: false,
      editor: null,
      editorOption: {
        placeholder: 'Add Template Description Here..',
      }
    },
    defaultIcon: '/static/album-icon.jpg',
    templateItems: [
      {
        id: 1,
        name: 'Pages',
        variants: []
      },
      {
        id: 2,
        name: 'Colors',
        variants: []
      },
    ],
    rules: {
      templateName: v => !!v.trim() || 'Template name is required',
      url: (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL'      
    },
    templateColors: {
      front_cover: '#7AC142',
      background_cover: '#F195BF',
      title_heading: '#63ACDE',
      border: '#019D8C',
      photo_border: '#019D8C',
      insidebackground_color: '#828282'
    },
    pickFrontCoverColor: false,
    pickBackCoverColor: false,
    pickBorderColor: false,
    pickTitleHeadColor: false,
    pickPhotoBorderColor: false,
    pickInsideBGColor: false
  }),
  computed: {
    ...mapGetters(['Account']),
    templateList: {
      get () {
        return store.state.Template;
      },
      set (value) {
        // updateSortList(this.entity, value);
        store.commit('setTemplate', value);
      }
    },
    TemplateItem: {
      get () {
        return store.state.TemplateItem;
      },
      set (value) {
        store.commit('setTemplateItem', value);
      }
    }
  },  
  created () {
    this.initialize();
  },
  methods: {
    async initialize () {
      if (!this.templateList.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.templateList = data;
          }
        }
      }
    },
    changedData () {
      this.editData.selectedData = true;
    },
    hideButtons () {
      this.editData.selectedData = false;
    },
    changeColor (newColor, area) {
      this.templateColors[area] = newColor.hex;
      this.changedData();
    },
    editItem (item) {
      this.$refs.templatesRef.scrollIntoView({ behavior: 'smooth' });
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.editIndex = this.templateList.indexOf(item);
      this.editData = Object.assign({}, item);
      this.templateColors = Object.keys(this.editData.style).length ? this.editData.style : this.templateColors;
      this.currentEditor = item.id;
      this.TemplateItem = {};
    },
    async save () {
      if (this.$refs.formEdit.validate()) {
        this.editData.style = this.templateColors;
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          this.templateList[this.editIndex] = data;
          swal.fire({
            type: 'success',
            title: 'Template updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    async fileSelected (files, themeIndex, type) {
      for (let i = 0; i < files.length; i++) {
        if (files[i] !== 'undefined') {
          this.imageName = files[i].name;
          if (this.imageName.lastIndexOf('.') <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[i]);
          fr.addEventListener('load', async () => {
            let imagePath = fr.result;
            let id = this.editData.id;
            let postUrl = 'Template/' + id + '/' + (type === 'Colors' ? 'Style' : 'Page');
            let response = await uploadFile(postUrl, files[i], 'PUT');
            if (!response.$data) {
              console.log('error', response.$error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: response.$error
              };
            } else {
              this.editData = response.$data;
              this.templateList[this.editIndex] = this.editData;

              // code to be removed further - fetching again to solve the binding issue
              // if (i === files.length - 1) {
              //   let { error, data } = await getCollection(this.entity, true);
              //   if (error) {
              //     console.log(error);
              //   } else {
              //     if (data.length > 0) {
              //       this.templateList = data;
              //       this.editData = this.templateList[this.editIndex];
              //     }
              //   }          
              // }
              // code to be removed further - fetching again to solve the binding issue
                        
              // this.editData.page.push();
              // this.imageFile = files[i];
              // if (this.templateItems.length) {
              //   let newId = this.templateItems[themeIndex].variants.length + 1;
              //   this.templateItems[themeIndex].variants.push({
              //     id: newId,
              //     name: '',
              //     src: imagePath,
              //     title: '',
              //     isCover: false
              //   });
              // }
            }
          });
        }
      }
    },    
    removeItem (item, variant) {
      if (item._id !== this.editData.default_page._id) {
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            if (variant === 'Page') {
              this.deleteIndex = this.editData.page.indexOf(item);
              this.editData.page.splice(this.deleteIndex, 1);
            } else {
              this.deleteIndex = this.editData.style.indexOf(item);
              this.editData.style.splice(this.deleteIndex, 1);
            }
            (async () => {
              let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
              if (error) {
                console.log('error', error);
              } else {
                this.editData.id = this.currentEditor;
                this.templateList[this.editIndex] = this.editData;
                swal.fire(
                  'Deleted!',
                  'The ' + variant + ' "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            })();          
          }
        });
      } else {
        swal.fire({
          type: 'warning',
          title: 'Cover Page',
          text: 'Please set another item as cover page to delete this!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }      
    },       
    backTolisting () {
      this.editIndex = -1;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },
    addNewTemplate () {
      this.TemplateItem = {};
      this.$router.push({ path: '/admin/templates/add' });
    },
    async sortList () {
      if (this.$refs.formEdit.validate()) {
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.editData.id = this.currentEditor;
          this.loading = false;
          this.templateList[this.editIndex] = data;
        }
      }      
    },
    async makeCover (item) {
      this.editData.default_page = item;
      if (this.$refs.formEdit.validate()) {
        let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
        } else {
          this.editData.id = this.currentEditor;
          this.loading = false;
          this.templateList[this.editIndex] = data;
          swal.fire({
            type: 'success',
            title: 'Cover page updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // this.selectedData = false;
            }
          });          
        }
      }      
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  }
};
</script>
<style scoped>
.button_div{
  min-height:60px;
  position: relative
}
.image_class{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 280px;
    width: 260px;
}
.instructions{
    min-height: 180px;
    background-color: #019d8c;
    margin-top: 10px;
    padding:20px;
    text-align: center;
 }
 .instructions_heading{
  background-color: #7ac143;
    text-align: center;
    color: #000;
    padding:10px;
 }
  .unselected_theme{
  text-align: center;
  padding: 3px 5px;
 }
  .selected_border{
  text-align: center;
  padding: 3px 5px;
  color:#fff;
 }
 .custom-width{
  min-width: auto;
 }
  .template-upload-icon {
    padding: 0px;
    margin: 0 -12px 0 0;
  }
  .custom-wrap {
    padding-bottom: 12px;
    padding-top: 23px;
  }
  .itemWrapper {
    padding: 24px;
    background: #f1f9f7;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Template/list.vue